import React, { FC } from 'react';

import styles from './styles.module.scss';

export const CurrentFilters: FC = () => (
  <div className={styles.currentFilters} />
);
